import type { IconSvgObject } from './types';

const AllBookmarkIcon: IconSvgObject = [
  ["path", { d: "M4 21.5V6.5C4 5.94772 4.44772 5.5 5 5.5H16C16.5523 5.5 17 5.94772 17 6.5V21.5L10.5 17.5L4 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 2.5H18C19.1046 2.5 20 3.39543 20 4.5V18.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AllBookmarkIcon;
